<template>
  <sModal
    v-model="mutableShow"
    :mask-closable="false"
    :retain-focus="false"
    :title="isEdit ? $t('OrgSettings.EditOrganizationSetting') : $t('OrgSettings.CreateOrganizationSetting')"
    @close="closeModal">
    <OrganizerSettingForm
      v-if="model"
      v-model="model"
      :button-text="$t('Common.Save')"
      :is-edit="isEdit"
      :loading="loading"/>
    <div
      key="footer"
      slot="footer">
      <sButton
        data-qa="btn-apply"
        :loading="loading"
        @click="handleSubmit">
        {{ isEdit ? $t('Common.Save') : $t('Common.Add') }}
      </sButton>
      <sButton
        data-qa="btn-close"
        type="text"
        @click="closeModal">
        {{ $t('Common.Cancel') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
import OrganizerSettingForm from 'components/organizer-settings/OrganizerSettingForm.vue'

import OrganizerSettingApi from '@/api/organizerSettingApi'
const organizer_setting_api = new OrganizerSettingApi()

export default {
  name: 'organizerSettingEdit',
  methods: {
    closeModal() {
      this.$emit('close')
      this.$nextTick(() => {
        this.mutableShow = false
      })
    },
    async handleSubmit() {
      let model = {}
      if (this.isEdit) {
        model = {
          settingOrganizationId: this.model.settingOrganizationId,
          settingValue: this.model.settingValue,
          users: this.model.users
        }
      } else {
        model = {
          organizationId: this.value.organizationView.organizationId,
          settingId: this.value.settingId,
          settingValue: this.model.settingValue,
          users: this.model.users
        }
      }
      this.$emit('update:loading', true)
      const endpointName = this.isEdit ? 'editOrganizerSetting' : 'addOrganizerSetting'
      await organizer_setting_api[endpointName](model)
        .then(res => {
          if (res.success) { // TODO: по идее, тут должно прийти true/false Сейчас ошибка. потом посмотрим
            const result = this.$_.cloneDeep(this.model)
            result.settingOrganizationId = this.model.settingOrganizationId
            result.settingValue = this.model.settingValue
            result.users = this.model.users
            this.$emit('update:model', result)
            this.$nextTick(() => {
              this.mutableShow = false
            })
            this.$emit(this.isEdit ? 'edit' : 'create', model)
          } else {
            this.$notice.warning({
              title: this.$t('Common.ErrorTitle'),
              message: this.$t(`OrgSettings.Errors.${res.message}`),
              duration: 10,
            })
          }
        }).catch(async (error) => {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: error,
            duration: 10,
          })
        })
        .finally(() => (
          this.$emit('update:loading', false)
        ))
      //this.setModal(false)
    },
  },
  computed: {
    mutableShow: {
      get() {
        return this.show
      },
      set(newValue) {
        this.$emit('update:show', newValue)
      }
    },
    model: {
      get() {
        return this.value
      },
      set(newValue) {
        if (this.loading) {
          return
        }
        this.$emit('update:model', newValue)
      }
    },
    isEdit() {
      return !!this.value?.settingOrganizationId
    }
  },
  props: {
    value: {
      type: Object
    },
    loading: {
      type: Boolean
    },
    show: {
      type: Boolean
    },
  },
  components: {
    OrganizerSettingForm
  }
}
</script>
